import { enGB, de } from "date-fns/locale";
import { Language } from "../../type/Translations.js";
const getLocale = (language) => {
  switch (language) {
    case Language.DEUTSCH: {
      return de;
    }
    default: {
      return enGB;
    }
  }
};
export {
  getLocale
};
